// extracted by mini-css-extract-plugin
module.exports = {"user__menu":"UserMenu_user__menu__32J0S","user__menu__text":"UserMenu_user__menu__text__99tl2"};